export default "__VITE_ASSET__DZER8D5$__"